import envCodes from '@/assets/js/envCodes'

const methods = {
  getCategoryCode() {
    return 'C000001'
  },
  getCurveFormItems(speedType) {
    const singleCurveFormItems = [
      {
        label: '风量',
        code: envCodes.wind,
        dataType: 'Number',
        suffix: 'm³/h',
        required: true,
      },
      {
        label: '全压',
        code: envCodes.pressure,
        dataType: 'Number',
        suffix: 'Pa',
        required: false,
      }
    ]
    const doubleCurveFormItems = [
      {
        label: '高速风量',
        code: envCodes.windHigh,
        dataType: 'Number',
        suffix: 'm³/h',
        required: true,
      },
      {
        label: '高速全压',
        code: envCodes.pressureHigh,
        dataType: 'Number',
        suffix: 'Pa',
        required: false,
      },
      {
        label: '低速风量',
        code: envCodes.windLow,
        dataType: 'Number',
        suffix: 'm³/h',
        required: false,
      },
      {
        label: '低速全压',
        code: envCodes.pressureLow,
        dataType: 'Number',
        suffix: 'Pa',
        required: false,
      },
    ]
    return speedType === 'DOUBLE_SPEED' ? doubleCurveFormItems : singleCurveFormItems
  },
}
export default {
  namespaced: true,
  ...methods
}
